import React from 'react';

type Props = {
    termsUrl?: string;
    privacyUrl?: string;
};

const TermsAndPrivacy = React.memo(function TermsAndPrivacy({
    termsUrl = '/terms/',
    privacyUrl = '/privacy/',
}: Props) {
    return (
        <div className="d-flex align-items-end justify-content-center mb-l5-40 flex-grow-1">
            <small className="text-center text-muted">
                By clicking “Create account” you agree to <br />
                Lumen5’s&nbsp;
                <a
                    href={termsUrl}
                    target="_blank"
                    rel="noreferrer"
                    className="text-decoration-underline text-reset"
                >
                    Terms of Use&nbsp;
                </a>
                and&nbsp;
                <a
                    href={privacyUrl}
                    target="_blank"
                    rel="noreferrer"
                    className="text-decoration-underline text-reset"
                >
                    Privacy Policy
                </a>
                .
            </small>
        </div>
    );
});

export default TermsAndPrivacy;
